import { Studente } from '../../../../api-clients/generated/services';
import { ChildMatch } from './command-parser.model';
import { levenshtein } from './levenshtein';

const MAX_LEVENSHTEIN_DISTANCE = 2;

export function matchChild(token: string, figli: Studente[], fuzzy: boolean): ChildMatch | null {
  const normalized = token.toLowerCase();

  // Skip multi-word placeholders
  if (normalized.startsWith('__')) return null;

  // 1. Exact match on nome
  const exact = figli.find(f => f.nome?.toLowerCase() === normalized);
  if (exact) return { studente: exact, status: 'matched' };

  // 2. Exact match on cognome
  const exactCognome = figli.find(f => f.cognome?.toLowerCase() === normalized);
  if (exactCognome) return { studente: exactCognome, status: 'matched' };

  // 3. startsWith on nome (unambiguous only)
  const prefixNome = figli.filter(f => f.nome?.toLowerCase().startsWith(normalized));
  if (prefixNome.length === 1) return { studente: prefixNome[0], status: 'matched' };

  // 4. startsWith on cognome (unambiguous only)
  const prefixCognome = figli.filter(f => f.cognome?.toLowerCase().startsWith(normalized));
  if (prefixCognome.length === 1) return { studente: prefixCognome[0], status: 'matched' };

  // 5. Levenshtein (only on full parse, not live)
  if (fuzzy && normalized.length >= 3) {
    const candidates = figli
      .map(f => {
        const distNome = levenshtein(normalized, (f.nome ?? '').toLowerCase());
        const distCognome = levenshtein(normalized, (f.cognome ?? '').toLowerCase());
        const minDist = Math.min(distNome, distCognome);
        return { studente: f, dist: minDist };
      })
      .filter(m => m.dist <= MAX_LEVENSHTEIN_DISTANCE)
      .sort((a, b) => a.dist - b.dist);

    if (candidates.length > 0) {
      return { studente: candidates[0].studente, status: 'fuzzy', originalInput: token };
    }
  }

  return null;
}
